<!--
 * @FilePath: DatePicker.vue
 * @Author: Aron
 * @Date: 2023-08-02 17:54:56
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-09-08 10:39:37
 * Copyright: 2023 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion:
-->
<template>
  <el-date-picker style="height:32px !important" v-bind="item.attrs" :start-placeholder="$t('app.startDatePlaceholder')" :end-placeholder="$t('app.endDatePlaceholder')"
    v-model="dateList" popper-class="date_form" @change="changeDate" @focus="pickerMinDate = ''" clearable
    :editable="false" :type="item.type || ''" ref="datePicker"
    :picker-options="item.picker ? pickerOptions : item.pickerOption ? itemPickOption : ''" unlink-panels
    :default-value="item.defaultDate ? defaultValue : null">
  </el-date-picker>
</template>

<script>
export default {
  data() {
    return {
      dateList: null,
      pickerMinDate: '',
      userSelectDate:'',
      itemPickOption: {
      }
    };
  },
  props: {
    item: {
      type: Object,
      default: {}
    }
  },
  computed: {
    pickerOptions() {
      return {
        shortcuts: [
          {
            text: this.$t('app.thisWeek'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setDate(start.getDate() - start.getDay() + 1);
              end.setDate(start.getDate() - start.getDay() + 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: this.$t('app.thisMonth'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setDate(1);
              end.setMonth(end.getMonth() + 1);
              end.setDate(0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: this.$t('app.lastWeek'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setDate(start.getDate() - start.getDay() - 6);
              end.setDate(end.getDate() - end.getDay());
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: this.$t('app.lastMonth'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 1);
              start.setDate(1);
              end.setDate(0);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      };
    },
    defaultValue() {
      const defaultDate = this.item.defaultDate;
      if (Array.isArray(defaultDate) && defaultDate.length === 2) {
        return defaultDate;
      }
      const today = new Date();
      const oneMonthAgo = new Date();
      oneMonthAgo.setMonth(today.getMonth() - 1);
      const startDate = this.formatDate(oneMonthAgo);
      const endDate = this.formatDate(today);
      return [startDate, endDate];
    }
  },
  watch: {
    item: {
      handler(newValue, oldValue) {
        if (newValue && newValue.attrs && newValue.attrs.defaultValue) {
          this.dateList = newValue.attrs.defaultValue;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    changeDate(val) {
      console.log(val, "val", val && val.length > 0, this.propName);
      console.log(this.$props.item.type, "type");
      this.dateList = val
      if (
        (val && val.length > 0) ||
        (val && this.$props.item.type === "month")
      ) {
        if (this.$props.item.type === "month") {
          let month = this.formatCDate(val);
          this.$emit("change", month, month);
          this.$emit("input", month);
        } else if (this.$props.item.type === "week") {
          this.$emit("change", val);
        } else {
          let beginTime = val[0];
          let endTime = val[1];

          this.$emit("change", beginTime, endTime);
          this.$emit("input", val);
        }
        console.log("查询");
      }  else if ((val && val.length > 0) ||
      (val && this.$props.item.type === "year")) {
        let year = this.formatCYear(val);
        this.$emit("change", year);
        this.$emit("input", year);
      }else {
        this.userSelectDate = '';
        //如果是清空，那么也要给外面进行清空
        this.$emit("change", null, null);
        this.$emit("input", null);
        console.log("清空");
      }
    },
    resetDatePicker() {
      this.dateList = null;
      this.userSelectDate = '';
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    formatCDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      return `${year}-${month}`;
    },
    formatCYear(date) {
      const year = date.getFullYear();
      return `${year}`;
    }
  },
  mounted() {
    if (this.$props.item.pickerOption) {
      const { firstDayOfWeek, onPick, disabledDate } = {  firstDayOfWeek: '', onPick: '', disabledDate: '',...this.$props.item.pickerOption }

      firstDayOfWeek && (this.itemPickOption.firstDayOfWeek = firstDayOfWeek)
      onPick && (this.itemPickOption.onPick = onPick.bind(this))
      disabledDate && (this.itemPickOption.disabledDate = disabledDate.bind(this))
    }

    if (this.$props.item.defaultDate) {
      this.dateList = this.defaultValue;
    }
  }
};
</script>

<style lang="scss" scoped>
:deep(.el-date-editor) {
  height: 32px !important;
}

// 范围时间选择图标放最后
:deep(.el-icon-date) {
  order: 1 !important;
}</style>
